import Collection from "../collection";

export { hashify, diffuse, eq, mapEl, };





function eq(a, b) {
    // todo not only { id }, but just id
    const std = arr => {
        const fn = arr.every( model => model.hasOwnProperty( 'id' ) )
            ? model => +model.id
            : el => el;

        return arr.map( fn ).sort().join( ',' );
    };

    return std( a ) === std( b );
}

function hashify(array = [], fn = (item, hash) => [item, true]) {
    if (array instanceof Collection)
        array = array.toJSON();
        
    return array.reduce( (hash, item) => { 
        const [key, value] = fn( item, hash ); 
        hash[key] = value != undefined ? value : true; 
        return hash; 
    }, {} );
}

function diffuse(array, fn) {
    if (!fn)
        return array.slice();

    return array.reduce( (result, item, index) => {
        let pivot; if (index)
            if (pivot = fn( array[index - 1], item ))
                result.push( pivot );

        return result.push( item ), result;
    }, [] );
}

function mapEl(array, findFn, newFn, mapFn) {
    array = [...array || []];

    const index = array.findIndex( findFn );
    const el = mapFn( array[index] || newFn() );

    if (el && index > -1)
        array[index] = el;
    else if (el)
        array.push( el );
    else if (index > -1)
        array.splice( index, 1 );

    return array;
}




// WEBPACK FOOTER //
// ./src/js/utils/arrays.js